var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMonRemoteDevices01 = function SvgMonRemoteDevices01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -18.88,
    y1: 143.67,
    x2: 161.07,
    y2: 14.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 21.72,
    y1: 200.41,
    x2: 201.67,
    y2: 71.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 48.4,
    y1: 237.7,
    x2: 228.35,
    y2: 108.95,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.62,129.85c1.73,0,3.13-1.4,3.13-3.13s-1.4-3.13-3.13-3.13H6.26V33.19c0-1.96,1.59-3.55,3.55-3.55h160.33c1.96,0,3.55,1.59,3.55,3.55v66.81c0,1.73,1.4,3.13,3.13,3.13s3.13-1.4,3.13-3.13V33.19c0-5.41-4.4-9.81-9.81-9.81H9.81c-5.41,0-9.81,4.4-9.81,9.81v106.89c0,5.41,4.4,9.81,9.81,9.81h56.58l-2.56,20.46h-3.92c-1.73,0-3.13,1.4-3.13,3.13s1.4,3.13,3.13,3.13h16.7c1.73,0,3.13-1.4,3.13-3.13s-1.4-3.13-3.13-3.13h-6.47l2.56-20.46h3.92c1.73,0,3.13-1.4,3.13-3.13s-1.4-3.13-3.13-3.13H9.81c-1.96,0-3.55-1.59-3.55-3.55v-10.23h70.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.42,83.51h-46.76c-5.41,0-9.81,4.4-9.81,9.81v73.49c0,5.41,4.4,9.81,9.81,9.81h46.76c5.41,0,9.81-4.4,9.81-9.81v-73.49c0-5.41-4.4-9.81-9.81-9.81ZM93.11,103.13h53.86v53.86h-53.86v-53.86ZM143.42,170.35h-46.76c-1.96,0-3.55-1.59-3.55-3.55v-3.55h53.86v3.55h0c0,1.96-1.59,3.55-3.55,3.55ZM146.97,96.87h-53.86v-3.55c0-1.96,1.59-3.55,3.55-3.55h46.76c1.96,0,3.55,1.59,3.55,3.55v3.55Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.19,110.23h-20.04c-5.41,0-9.81,4.4-9.81,9.81v46.76c0,5.41,4.4,9.81,9.81,9.81h20.04c5.41,0,9.81-4.4,9.81-9.81v-46.76c0-5.41-4.4-9.81-9.81-9.81ZM190.19,170.35h-20.04c-1.96,0-3.55-1.59-3.55-3.55v-3.55h27.14v3.55h0c0,1.96-1.59,3.55-3.55,3.55ZM193.74,156.99h-27.14v-27.14h27.14v27.14ZM193.74,123.59h-27.14v-3.55c0-1.96,1.59-3.55,3.55-3.55h20.04c1.96,0,3.55,1.59,3.55,3.55v3.55Z"
  })));
};
export default SvgMonRemoteDevices01;